export { QRScanner } from "./QRScanner";
export type { QRScannerProps } from "./QRScanner";
